import { Accept } from 'react-dropzone'

export const ACCEPTED_PICTURE_FILE_FORMATS: Accept = {
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
}
